<template>
    <CFooter :fixed="false">
        <div>
        </div>
        <div class="mfs-auto">
            <a href="https://mircity24.ru" target="_blank">mircity24.ru</a>
            <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
        </div>
    </CFooter>
</template>

<script>
    export default {
        name: 'TheFooter'
    }
</script>
